import {useState} from 'react'

import {BatteryAlertIcon} from '../../asset/image/icon'
import {t} from '../../engine'
import {CursorTooltip} from '.'

export interface BatteryAlertProps {
  batteryLevel?: number
  batteryTimestamp?: number
}

/* styled label for form inputs, use LabelBox instead if possible*/
export const BatteryAlert = (props: BatteryAlertProps) => {
  const {batteryLevel, batteryTimestamp} = {...props}

  const tooltipText = `Garmin device battery level less than 20%.
                
    Updated at ${t.formatTimestampToPrettyDate(batteryTimestamp ?? 0)}`

  const [tooltip, setTooltip] = useState({
    open: false,
    x: 0,
    y: 0,
    text: tooltipText,
  })

  const onMouseMove = (e: {clientX: number; clientY: number}) => {
    setTooltip((t) => ({...t, x: e.clientX, y: e.clientY}))
  }

  const onMouseEnter = () => {
    setTooltip((t) => ({...t, open: true}))
  }

  const onMouseLeave = () => {
    setTooltip((t) => ({...t, open: false}))
  }

  if (batteryLevel !== undefined && batteryTimestamp && batteryLevel < 20) {
    return (
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseMove={onMouseMove}>
        <div css={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <img src={BatteryAlertIcon} width='33' height='24' css={{margin: '5px'}} />
          <CursorTooltip {...tooltip} />
        </div>
      </div>
    )
  }
  return <></>
}
